import moment from 'moment'
import { createAppSlice } from 'app/createAppSlice'

const today = moment().endOf('day').toDate()
const threeMonthsAgo = moment(today)
  .subtract(3, 'months')
  .startOf('day')
  .toDate()

const initialState = {
  tag: {
    size: 10,
    page: 0,
    from: threeMonthsAgo.toISOString(),
    to: today.toISOString(),
    sortby: undefined,
    sortdir: undefined,
    s: undefined,
    today: undefined,
    byUserId: undefined,
  },
  isOpenModal: false,
  isOpenModalVerify: false,
  loading: false,
  activeTab: 'all',
}

export const reportAttendanceSlice = createAppSlice({
  name: 'reportAttendance',
  initialState,
  reducers: (create) => ({
    setFetchOption: create.reducer((state, { payload }) => {
      state.tag = { ...state.tag, ...payload }
    }),
    toggleModal: create.reducer((state) => {
      state.isOpenModal = !state.isOpenModal
    }),
    toggleModalVerify: create.reducer((state) => {
      state.isOpenModalVerify = !state.isOpenModalVerify
    }),
    setActiveTab: create.reducer((state, { payload }) => {
      state.activeTab = payload
    }),
  }),
})

export const { toggleModal, setFetchOption, toggleModalVerify, setActiveTab } =
  reportAttendanceSlice.actions

export default reportAttendanceSlice.reducer
